import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'CYCLING',
    text: 'Cycling is easy on the joints and a great cardio exercise for losing weight. Give a spin class a go, and with the help of high energy music, an encouraging instructor and the group atmosphere you’ll get a mix of sprints, hills and recovery to burn up to 600 calories an hour!',
  },
  {
    title: 'ROWING',
    text: 'Rowing is deceptively challenging if done right. To really get the most from your rowing workout, you should aim for shorter bursts of intensity to mix the anaerobic and aerobic exercise. 10 minutes of intervals are much more effective than cruising for half an hour.',
  },
  {
    title: 'BOXING',
    text: 'Boxing offers stress relief and will improve your hand-eye co-ordination, balance and reactivity. Not to mention being really fun.',
  },
  {
    title: 'SWIMMING',
    text: 'Swimming is a low-impact activity that blasts fat. You’ll burn around 350 calories for every half hour of breaststroke.',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">10 cardio workouts you can do in the gym to burn calories</h1>
      <p>Learn Workout Techniques</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;
